import { render, staticRenderFns } from "./CompanyUserData.vue?vue&type=template&id=06ddba9c"
import script from "./CompanyUserData.vue?vue&type=script&lang=js"
export * from "./CompanyUserData.vue?vue&type=script&lang=js"
import style0 from "./CompanyUserData.vue?vue&type=style&index=0&id=06ddba9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports